export const fontsWeights = {
    "300": "Legère",
    "400": "Normale",
    "700": "Epaisse",
};
